import React from 'react'
import HighRiskBanner from "../components/img/HighRiskBanner.jpg"
const HighRiskPregnancyBanner = () => {
  return (
    <div>
      <div id="carouselExampleCaptions" className="carousel slide" data-bs-ride="carousel">
        <div className="carousel-inner">
          <div className="carousel-item active">
            <img src={HighRiskBanner} className="d-block w-100 carousel-image" alt="..." />
          </div>
        </div>
      </div>
    </div>
  )
}

export default HighRiskPregnancyBanner
